import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { ReportsHeadset } from 'src/models';
import { RootState } from 'src/store';
import { headsetsSelectors } from 'src/store/reducers/reportHeadsets';

export const useReportsHeadsetsState = (): RootState['reportsHeadsets'] => {
  const state = useSelector<RootState, RootState['reportsHeadsets']>(
    (state) => state.reportsHeadsets,
  );

  useDebugValue(state);

  return state;
};

export const useReportsHeadsets = (): ReportsHeadset[] => {
  const state = useSelector<RootState, RootState['reportsHeadsets']>(
    (state) => state.reportsHeadsets,
  );

  const headsets = headsetsSelectors.selectAll(state);

  useDebugValue(headsets);

  return headsets;
};
